import { Dayjs } from 'dayjs';
import * as React from 'react';

import { Race } from '@/lib/apollo/types/gen/graphql';

import { BetLink, Cancel, NotReleasedOrEndText, ResultLink } from './style';

interface RaceLinkProps {
  race?: Race;
  isCanceled: boolean; // レース中止フラグ
  isRaceProgramCanceled: boolean; // 開催中止フラグ
  isReleased: boolean;
  heldDate: Dayjs;
  velodromeName: string;
  onClick?: React.DOMAttributes<HTMLElement>['onClick'];
}

const RaceLink: React.FC<RaceLinkProps> = ({
  race,
  isCanceled,
  isRaceProgramCanceled,
  isReleased,
  heldDate,
  velodromeName,
  onClick,
}) => {
  // 開催中止となった場合
  if (isRaceProgramCanceled) {
    return <Cancel>中止</Cancel>;
  }

  // レースデータが同期されていない場合
  if (!isReleased) {
    return <NotReleasedOrEndText>発売前</NotReleasedOrEndText>;
  }

  // レースが全て終了した場合
  if (!race || isCanceled) {
    return (
      <ResultLink
        to={`/${velodromeName}/race/${heldDate.format('YYYY-MM-DD')}/result`}
        onClick={onClick}
      >
        結果
      </ResultLink>
    );
  }

  return (
    <BetLink
      to={`/${velodromeName}/race/${heldDate.format('YYYY-MM-DD')}/${
        race.raceNum
      }`}
      onClick={onClick}
    >
      投票
    </BetLink>
  );
};

export default RaceLink;
